import { KeyMetric } from '@/components/KeyMetric';
import { CompanyIntrinsicDiscountBase } from '@/components/CompanyIntrinsicDiscount';
import { toTruncated } from '@/utilities/formatting';

type Props = {
  formattedFairValue: string;
  targetIntrinsicDiscount: number | null;
  targetRevenuePercentageChange: number | null;
};

export const ValuationMetrics = ({
  formattedFairValue,
  targetIntrinsicDiscount,
  targetRevenuePercentageChange,
}: Props) => {
  return (
    <div className="grid max-h-x6 grid-cols-[max-content_max-content] gap-x2">
      <KeyMetric color="chart03">
        <div className="grid grid-rows-[max-content_max-content]">
          <div className="text-lg font-strong text-solid">
            {formattedFairValue}
          </div>
          <div className="grid grid-cols-[max-content_max-content] items-center gap-1 text-tiny">
            <div className="text-soft">FV</div>
            <CompanyIntrinsicDiscountBase
              discount={targetIntrinsicDiscount ?? null}
            />
          </div>
        </div>
      </KeyMetric>
      {typeof targetRevenuePercentageChange === 'number' && (
        <KeyMetric color="brand01">
          <div className="grid grid-rows-[max-content_max-content]">
            <div className="text-lg font-strong text-solid">
              {toTruncated(targetRevenuePercentageChange, 2)}%
            </div>
            <div className="text-tiny text-soft">Revenue growth p.a.</div>
          </div>
        </KeyMetric>
      )}
    </div>
  );
};
